import * as THREE from 'three';
import Camera from './utils/Camera.js';
import Renderer from './utils/Renderer.js';
import SceneLights from './helpers/SceneLights.js';
// import * as dat from "dat.gui";
import Sizes from './utils/Sizes.js';
import ModelLoader from '../../../pkg/utils/GLTFLoader.js';
import ThreejsApplication from '../../../pkg/ThreejsApplication.js';
import useModelsUtils from '../../../pkg/utils/use-models-utils.js';
import { Tween, Easing } from "@tweenjs/tween.js";

let instance = null;
const { setAnimation } = useModelsUtils();

export class RiffleApplication extends ThreejsApplication {
  constructor(eventEmitter) {
    super();

    if (instance) return instance;
    instance = this;

    this.camera = null;
    this.scene = new THREE.Scene();
    this.renderer = null;
    this.debugObject = {};
    this.canvas = null;
    this.canvasDomElement = null;
    this.loadedModel = null;
    this.eventEmitter = eventEmitter;
    this.raycaster = new THREE.Raycaster();
    this.sizes = null;
    this.sceneLights = new SceneLights(this);
    this.modelLoader = new ModelLoader(this)

    this.fps = 30;
    this.interval = 1000 / this.fps;
    this.then = Date.now();

    // this.gui = new dat.GUI();
  }

  async build(canvas, canvasDomElement) {
    await this.modelLoader.initGLTFLoader()
    this.canvas = canvas;
    this.canvasDomElement = canvasDomElement;
    this.sizes = new Sizes(canvasDomElement);

    this.camera = new Camera(this);
    this.renderer = new Renderer(this, true);

    // resize event
    this.resize();
    this.sizes.subscribe('resize', () => {
      this.resize();
    });
    this.sceneLights.initializeLights();

    this.cameraInfo = document.getElementById('cameraInfo');
  }

  /**
   * INITIALIZATION
   */
  animateFrame() {
    setAnimation(this);

    if (this.tweenAnimation) {
      this.tweenAnimation.update()
    }

    // this.updateCameraInfoHtml();
  }

  updateCameraInfoHtml() {
    if (!this.cameraInfo || !this.camera) {
      return;
    }
    const cameraPos = this.camera.instance.position;

    this.cameraInfo.innerHTML = `
      <span>X: ${cameraPos.x.toFixed(2)}</span>
      <span>Y: ${cameraPos.y.toFixed(2)}</span>
      <span>Z: ${cameraPos.z.toFixed(2)}</span>
    `;
  }

  resize() {
    this.camera.resize();

    const now = Date.now();
    const elapsed = now - this.then;

    if (elapsed > this.interval) {
      this.renderer.resize();
    }
  }

  /**
   * LOAD MODEL
   */
  async loadModel(url) {
    console.log(this.loadedModel)
    this.loadedModel = await this.modelLoader.loadModel(url)
    this.scene.add(this.loadedModel.scene);

    this.mixer = new THREE.AnimationMixer(this.loadedModel.scene);
    const clips = this.loadedModel.animations;

    const startAction = this.mixer.clipAction(clips.find(clip => clip.name === 'Start'));
    const loopAction = this.mixer.clipAction(clips.find(clip => clip.name === 'Loop'));
    startAction.setLoop(THREE.LoopOnce);
    startAction.clampWhenFinished = true;
    startAction.timeScale = 1;
    loopAction.setLoop(THREE.LoopRepeat);
    loopAction.timeScale = 1;
    this.mixer.addEventListener('finished', (e) => {
      if (e.action === startAction) {
        loopAction.reset().play();
      }
    });
    startAction.play();
    console.log(this.loadedModel, ' this.loadedModel');
    const mesh = this.scene.getObjectByName("Riffle_Fresnel")
    if (!mesh) {
      throw Error('Mesh Riffle_Fresnel not found');
    }

    const tweenObj = { emissiveIntensity: 0 }
    mesh.material.emissiveIntensity = 0
    // mesh.material.wireframe = true
    this.tweenAnimation = new Tween(tweenObj, false)
    .to(
      {
        emissiveIntensity: 1,
      },
      7000
    )
    .easing(Easing.Linear.In)
    .onUpdate(() => {
      mesh.material.emissiveIntensity = tweenObj.emissiveIntensity
    })
    .start()

    // this.loadedModel.scene.traverse((el) => {
    //   if (el.isMesh) {
    //     el.castShadow = true;
    //     el.receiveShadow = true;
    //   }
    // });

    this.eventEmitter.notify('setInitFinished');

    setTimeout(() => {
      this.resize();
    }, 200);
  }
}
